import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { AdvertiserSubSectorCreationFormComponent } from '../../components/advertiser-sub-sector-creation-form/advertiser-sub-sector-creation-form.component';
import { Tag } from '~core/models/tag.models';

@Component({
  selector: 'advertiser-sub-sector-creation-dialog',
  standalone: true,
  imports: [AdvertiserSubSectorCreationFormComponent],
  templateUrl: './advertiser-sub-sector-creation-dialog.component.html',
  styleUrl: './advertiser-sub-sector-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserSubSectorCreationDialogComponent extends BaseComponent {
  subSector = input<Tag>();
}
